// extracted by mini-css-extract-plugin
module.exports = {"block":"_15427","inclusion":"_685","title":"_355","content":"_11831","desc":"_13152","line":"_3817","text":"_17726","more":"_4334","arrow":"_13567","fold":"_5883"};